<template lang="pug">
v-main
  v-container(fluid)
    v-dialog( width="420px" style="overflow:hidden; " v-model="reqTypeDialog" persistent)
      v-card
        h1(style="background: #E0E0E0; padding: 0.5rem; padding-left:1rem; font-size: large;") Select Request
        div(style="padding: 0rem 1rem 0 1rem;")
          select( required id="hmCrMemoSlec" placeholder="Select Type" v-model="createMemoReqType" style="outline:none;border-bottom: 1px solid;width: 100%;margin-bottom: 1rem;padding: 0.1rem 0.5rem; ; margin: 2rem 0")
            option(value='' hidden selected="true" disabled="true") Select Type
            option(id='homeSelectGeneral' value='General') General Request
            option(id='homeselectPayment' value='Payment') Payment Request
            option(id='homeselectAnnouncement' value='Announcement') IM Announcement

          v-card-actions(style="padding-top:0; justify-content: right; padding-bottom:1.4rem")
            v-btn(depressed, large, id='homeSelectCreateMemoTypeCancle' style="color:#000; backgound:#f5f5f5; margin-right:.3rem"  @click="reqTypeDialog = false; createMemoReqType = ''") Cancel
            v-btn(depressed, large, id='homeSelectCreateMemoTypeCreate' color="primary" @click="createMemo(); reqTypeDialog = false; ; createMemoReqType = ''") Create
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title {{ title }}
      v-divider
      v-card-text
        h3(style="font-weight: 400; color: black") Welcome to i-Memo TechConnect
        p.mt-2 This iMemo is platform will support all NonGroup memo activities
        .custom-border.mt-5.pa-6.image-head
          .text-center
            h2 Getting started
            p.mt-2 Great to have you on board! Feel free to explore, or get a head start below.
          v-row
            v-col(cols="6", md="4")
              div(id="homeCreateMemo" @click="reqTypeDialog = true" style="cursor: pointer;")
                v-card.custom-card(
                  style="min-height: 200px; padding: 2rem",
                  outlined,
                  tile
                ) 
                  |
                  |
                  |
                  |
                  v-icon.card-icon insert_drive_file

                  .card-title Start Creating Memo
                  .card-subtitle Create a new memo and work with rest of the team.
            v-col(cols="6", md="4")
              router-link(:to="{ name: 'Faq' }")
                v-card.custom-card.blinking(
                  style="min-height: 200px; padding: 2rem",
                  outlined,
                  tile,
                  @click="clickCard"
                ) 
                  |
                  |
                  |
                  |
                  v-icon.card-icon live_help
                  .card-title Frequently Asked Questions
                  .card-subtitle Have a question about iMemo? We are here to help.
                  div(style="float: inline-start")
                    lottie-animation.img-icon(
                      v-if="animationTime == 1 && animationPointer == false",
                      ref="anim",
                      :animationData="require('../assets/pointer_blue.json')",
                      :loop="3",
                      :autoPlay="true",
                      @complete="complete",
                      style="width: 100px; height: 100px; margin-left: -50px; float: left; margin-top: -45px"
                    )
            v-col(cols="6", md="4")
              router-link(:to="{ name: 'My Approval' }")
                v-card.custom-card(
                  style="min-height: 200px; padding: 2rem",
                  outlined,
                  tile
                ) 
                  |
                  |
                  v-icon.card-icon beenhere
                  .card-title Start Approval Memo
                  .card-subtitle Do memo approval easily on approval page

        .mt-5.pa-6.custom-border.bg-gray(v-if="changeLog.releaseDate")
          p.title__feature(
            style="margin: 0; font-family: Roboto; font-size: 20px; font-weight: 400; line-height: 23px; letter-spacing: 0em; text-align: left"
          ) Feature New Release v{{ changeLog.version }} - {{ changeLog.releaseDate }}
            img(
              src="../assets/icon/Vector.png",
              style="width: 22px; vertical-align: middle; margin: 0.2rem"
            )
            p(
              style="margin: 0; padding-top: 0.4rem; font-size: 16px; font-weight: 400; line-height: 30px; letter-spacing: 0em; text-align: left",
              v-for="(item, index) in changeLog.changes",
              :key="index"
            ) {{ index + 1 }}. {{ item }}
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import axios from "axios";
export default {
  name: "HomeUsers",
  components: {
    LottieAnimation,
  },
  props: {
    title: "",
  },
  data() {
    return {
      createMemoReqType:"",
      reqTypeDialog: false,
      changeLog: {},
      animationPointer: true,
      animationTime: 0,
    };
  },
  mounted() {
    this.checkAnimation();
    this.getReleaseNote();
  },
  methods: {
    createMemo() {
      if (this.createMemoReqType == 'General') {
        //- setCreateMemoRequestType()
        this.$store.commit('setCreateMemoRequestType', "General");
        this.$router.push('/create-memo');
      } else if (this.createMemoReqType == 'Payment') {
        
        //- THERW WILL BE A NEW PAGE CALLED CREATE PAYMENT MEMO SOON
        this.$store.commit('setCreateMemoRequestType', "Payment");
        this.$router.push('/create-payment-memo');
      } else if (this.createMemoReqType == 'Announcement') {
        this.$store.commit('setCreateMemoRequestType', "Announcement");
        this.$router.push('/create-announcement-memo');
      }
    },
    getReleaseNote() {
      // const IMEMO_VERSION_DATE = new Date(`${process.env.IMEMO_VERSION_DATE}T23:59:59`)
      // const isExpire = Math.ceil((SERVER_TIME - IMEMO_VERSION_DATE) / 24 / 60 / 60 / 1000) >= +process.env.IMEMO_VERSION_EXPIRE_IN_DAYS;
      // if (!isExpire) {

      axios
        .post(
          `${process.env.VUE_APP_API}/release-info/list`,
          {
            role: ["general"],
            version: process.env.IMEMO_VERSION,
            sortBy: "createdAt",
            direction: 1,
            page: 1,
            perPage: -1,
            keyword: "",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          if (res.data.data.length != 0) {
            this.changeLog = res.data.data[res.data.data.length - 1];
            const monthNames = [
              "Jan",
              "Febr",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];
            let dt = new Date(this.changeLog.releaseDate);
            var d = dt.getDate();
            var m = monthNames[dt.getMonth()]; //Month from 0 to 11
            var y = dt.getFullYear();
            this.changeLog.releaseDate =
              (d <= 9 ? "0" + d : d) + " " + m + " " + y;
          }
        })
      // }
    },
    checkAnimation() {
      if (localStorage.animationPointer == null) {
        this.animationPointer = false;
      }
      if (localStorage.animationTime !== "0") {
        this.animationTime = 1;
      }
    },
    clickCard() {
      this.animationPointer = true;
      localStorage.setItem("animationPointer", true);
    },
    complete() {
      this.animationTime = 0;
      localStorage.setItem("animationTime", 0);
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}

div .image-head {
  background-image: url("../assets/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

a {
  text-decoration: none;
}

.custom-card {
  padding: 3rem;
  text-align: center;
}

.card-title {
  font-size: 16px;
  color: #646464;
  font-weight: 600;
}

.card-subtitle {
  font-size: 14px;
  color: #a7a7a7;
}

.custom-card:hover .img-icon {
  display: none;
}

.custom-card:hover .vcon {
  display: block;
}

.theme--light.v-card .custom-card:hover {
  background: #1976d2;
  color: #fff !important;
}

.theme--light.v-card .custom-card:hover .card-title {
  color: #fff;
}

.theme--light.v-card .custom-card:hover .card-subtitle {
  color: #fff;
}

.theme--light.v-card .custom-card:hover .card-icon {
  color: #fff !important;
}

.card-icon {
  color: #1976d2 !important;
  margin-bottom: 0.4rem;
}

.custom-card.theme--light.v-sheet--outlined {
  border: 2px solid #efeff0;
}

.blinking {
  animation-name: blinking;
  animation-duration: 1s;
  animation-iteration-count: 100;
}
@keyframes blinking {
  50% {
    border: 2px solid #1976d2;
  }
}

.custom-border {
  border: 1px solid #1976d2 !important;
  border-radius: 3px;
}

.title__feature {
  color: #000000;
  font-size: 16px;
}

.bg-gray {
  background: #f2f2f2;
}
</style>